var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { PureComponent } from "react";
import Button from "@irati/ui/src/Button";
import Loading from "@irati/ui/src/Loading";
import Form from "@irati/ui/src/Form";
import { ValidationButton } from "@irati/ui/src/FormItem";
import { Label2, Strong } from "@irati/ui/src/Labels";
import mfaService from "@irati/auth/services/mfa";
import { MFAPhoneNumber } from "@irati-web/fields/mfa";
import FormattedMessage from "@irati/utils/lang";
import { mfaTracking } from "@irati-tracking/platform";
import { Modal } from "../BaseModal";
import { Screens } from "./index";
import { ButtonContainer } from "./styled";
var MFAPopupSetup = /** @class */ (function (_super) {
    __extends(MFAPopupSetup, _super);
    function MFAPopupSetup() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            phoneNumber: "",
            submit: null
        };
        _this.handleSuccess = function () {
            var submit = mfaService.setup(_this.state.phoneNumber).then(function (mfa) {
                var phoneNumber = mfa.phoneNumberLastDigits;
                _this.props.selectScreen(Screens.ENTER, { phoneNumber: phoneNumber });
                mfaTracking.popupSetupComplete();
            });
            _this.setState({ submit: submit });
        };
        _this.handleChange = function (phoneNumber) { return _this.setState({ phoneNumber: phoneNumber }); };
        _this.handleCancel = function () {
            _this.props.onCancel();
            mfaTracking.popupSetupCancel();
        };
        return _this;
    }
    MFAPopupSetup.prototype.componentDidUpdate = function (prevProps) {
        if (prevProps.show === false && this.props.show === true) {
            mfaTracking.popupSetupShown();
        }
    };
    MFAPopupSetup.prototype.render = function () {
        return (React.createElement(Modal, { show: this.props.show, header: "platform.mfa.setup.title" },
            React.createElement(Label2, { block: true, small: true },
                React.createElement(FormattedMessage, { id: "platform.mfa.setup.bodyWithBoldText", values: { boldText: React.createElement(Strong, { dosis: false },
                            React.createElement(FormattedMessage, { id: "platform.mfa.setup.boldText" })) } })),
            React.createElement(Form, null,
                React.createElement(MFAPhoneNumber, { value: this.state.phoneNumber, onChange: this.handleChange })),
            React.createElement(Loading, { load: this.state.submit, useLoader: false }),
            React.createElement(ButtonContainer, null,
                React.createElement(Button, { onClick: this.handleCancel },
                    React.createElement(FormattedMessage, { id: "platform.mfa.setup.cancel" })),
                React.createElement(ValidationButton, { onClick: this.handleSuccess, primary: true, load: this.state.submit },
                    React.createElement(FormattedMessage, { id: "platform.mfa.setup.submit" })))));
    };
    return MFAPopupSetup;
}(PureComponent));
export default MFAPopupSetup;
